import React, { useEffect, useState } from "react";
import classNames from "classnames/bind";
import { Pagination, Table as TB } from "../../../components";
import useFetchData from "../../../hooks/useFetchData";
import Filter from "../Access/Filter/Filter";
import { formatDateToTime, formatDateYesterday, formatDB, sorterArray } from "../../../utils";
import styles from './Equipment.module.css'
import { useStoreContext } from "../../../hooks/useStoreContext";
import NameCol from "../../../components/NameCol";
import Nodata from "../NoData/Nodata";

const cx = classNames.bind(styles);
const Equipment = () => {
  const [pages, setPages] = useState(1)
  const [currentPage, setCurrentPage] = useState(1)
  const [userName, setUserName] = useState('')
  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState()
  const [textSearch, setTextSearch] = useState()
  const [toggleSort, setToggleSort] = useState(false)
  const [dataTable, setDataTable] = useState()
  const [method, setMethod] = useState('')
  // eslint-disable-next-line
  const [dataStore, dispatch] = useStoreContext()
  useEffect(() => {
    setUserName(dataStore.userName)
  }, [dataStore])
  const { data } = useFetchData("/deviceHistory/get-list-device-history/",
    {
      page: currentPage,
      size: 10,
      username: userName,
      day_start: startDate && formatDB(startDate),
      day_end: endDate && formatDB(endDate),
      device: textSearch,
    }
  );

  useEffect(() => {
    const newData = data ? data : null
    if (newData && method.length > 0) {
      switch (toggleSort) {
        case 'up':
          const dataSortUp = sorterArray(newData.data, method)
          setDataTable(dataSortUp)
          break;
        case 'down':
          const dataSortDown = sorterArray(newData.data, method)
          setDataTable(dataSortDown.reverse())
          break;
        default:
          setDataTable(newData.data)
          break;
      }
    } else {
      setDataTable(newData.data)
    }
  }, [data, toggleSort, method])

  const handleSort = (type, method) => {
    if (type !== toggleSort) {
      setToggleSort(type)
      setMethod(method)
    } else {
      setToggleSort(false)
      setMethod('')
    }
  }



  useState(() => {
    const dateNow = new Date()
    const time = formatDateYesterday(dateNow)
    setStartDate(time);
    setEndDate(time)
  }, [])

  const dataSource = dataTable?.map((item, index) => {
    return {
      stt: index + 1,
      date: formatDateToTime(item.TIME),
      equipment: item.DEVICE,
      type: item.TYPE_DEVICE.toLowerCase(),
      event: item.EVENT,
    };
  });

  const columns = [
    {
      label: "STT",
      key: "stt",
    },
    {
      label: <NameCol active={method} title={'Thiết bị'} handleSort={handleSort} method={'DEVICE'} />,
      key: "equipment",
    },
    {
      label: <NameCol active={method} title={'Loại thiết bị'} handleSort={handleSort} method={'TYPE_DEVICE'} />,
      key: "type",
    },
    {
      label: <NameCol active={method} title={'Sự kiện'} handleSort={handleSort} method={'ACTION_NAME'} />,
      key: "event",
    },
    {
      label: <NameCol active={method} title={'Thời gian'} handleSort={handleSort} method={'TIME'} />,
      key: 'date'
    },
  ];
  useEffect(() => {
    if (data) {
      if (data?.count > 10) {
        let length = data?.count
        setPages(Math.ceil(length / 10))
      } else {
        setPages(1)
      }
    }
  }, [data])

  const handleNext = () => {
    setCurrentPage(currentPage + 1);
  };

  const handlePrevious = () => {
    setCurrentPage(currentPage - 1);
  };

  const handleClick = (page) => {
    setCurrentPage(page);
  };

  const onChangeDateStart = (data) => {
    setStartDate(data);
  };

  const onChangeDateEnd = (data) => {
    setEndDate(data);
  };

  const handleChangeSearch = (data) => {
    setTextSearch(data);
    setCurrentPage(1)
  }
  return (
    <>
      <div className={cx("header")}>
        <h1 className={cx("title")}>Lịch sử thiết bị</h1>
      </div>
      <div className={cx('content')}>
        <Filter
          dayStart={startDate}
          dayEnd={endDate}
          onChangeDayStart={onChangeDateStart}
          onChangeDayEnd={onChangeDateEnd}
          changeTextSearch={handleChangeSearch}
        />
        <TB data={dataSource} colum={columns} />
        {dataSource?.length > 0 ?  <div className={cx("pagination")}>
          <Pagination
            onClick={handleClick}
            onNext={handleNext}
            onPrevious={handlePrevious}
            pages={pages}
            currentPage={currentPage}
          />
        </div>:<Nodata/>}
      </div>
    </>

  );
};

export default Equipment;
